import { render, staticRenderFns } from "./VVerify.vue?vue&type=template&id=6f77cc66&"
import script from "./VVerify.vue?vue&type=script&lang=js&"
export * from "./VVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports